module.exports = __webpack_public_path__ + "static/media/Aug_2025_1.d1ea5799.webp";